/* eslint-disable import/prefer-default-export */
import {
    convertNullableDateTimeToUkgUserDateTime, applyUkgUserTimeZoneTransformation, convertRequestPeriodEndDate,
} from '@commonClient2/services/ukgDateTime';
import { simplifySequentialSchedule } from '../../../../Manager/services/BidProfileModelMapper';

/**
 * @param {ApiEmployee.GetBidProfileResponse} response
 * @returns {EmployeeBidProfile.IDetailedEmployeeBidProfile}
 */
export const parseEmployeeBidProfileServerModel = (response) => {
    /**
     * @type {EmployeeBidProfile.IDetailedEmployeeBidProfile}
     */
    const bidProfile = {
        ...response.data,
        creationDate: applyUkgUserTimeZoneTransformation(response.data.creationDate),
        signOffDate: convertNullableDateTimeToUkgUserDateTime(response.data.signOffDate),
        lastUpdate: applyUkgUserTimeZoneTransformation(response.data.lastUpdate),
        employeeSubmissionDate: convertNullableDateTimeToUkgUserDateTime(response.data.employeeSubmissionDate),
        submissionPeriodStartDate: applyUkgUserTimeZoneTransformation(response.data.submissionPeriodStartDate),
        submissionPeriodEndDate: applyUkgUserTimeZoneTransformation(response.data.submissionPeriodEndDate),
        requestPeriodStartDate: applyUkgUserTimeZoneTransformation(response.data.requestPeriodStartDate),
        requestPeriodEndDate: convertRequestPeriodEndDate(response.data.requestPeriodEndDate),
        isForeverRequestPeriod: response.data.isForeverRequestPeriod,
        employeeSequentialSchedule: response.data.employeeSequentialSchedule ? {
            ...response.data.employeeSequentialSchedule,
            employeeSubmissionStartDate: applyUkgUserTimeZoneTransformation(
                response.data.employeeSequentialSchedule?.employeeSubmissionStartDate,
            ),
            employeeSubmissionEndDate: applyUkgUserTimeZoneTransformation(
                response.data.employeeSequentialSchedule?.employeeSubmissionEndDate,
            ),
        } : null,
        warnings: [],
        sequentialSchedule: simplifySequentialSchedule(response.data.sequentialSchedule),
    };

    return bidProfile;
};
/**
 * @param {string[]} selection
 * @returns {EmployeeBidSelection.IPreferentialBidSelection} parsedSelection
 */
export const bidSelectionToMap = (selection) => {
    /** @type {EmployeeBidSelection.IPreferentialBidSelection} */
    const parsedSelection = {};
    selection.forEach((value, index) => {
        parsedSelection[index + 1] = value;
    });
    return parsedSelection;
};
